// Central content + media for Mauresk Services

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1727461553668-45322401f863?crop=entropy&cs=srgb&fm=webp&q=78&w=1920&ixlib=rb-4.1.0",
  heroPortrait:
    "https://images.unsplash.com/photo-1758797849151-1725021be42a?crop=entropy&cs=srgb&fm=webp&q=80&w=1200&ixlib=rb-4.1.0",
  about:
    "https://images.unsplash.com/photo-1758797849151-1725021be42a?crop=entropy&cs=srgb&fm=webp&q=80&w=1600&ixlib=rb-4.1.0",
  aboutCard:
    "https://customer-assets-jai6qajn.emergentagent.net/job_mauresk-offshore/artifacts/lo776zgd_ecc3d685887e8ecb09e753c49f8fd175.webp",
  aboutSecondary:
    "https://images.unsplash.com/photo-1642864835712-a9e172ceeafe?crop=entropy&cs=srgb&fm=webp&q=80&w=1200&ixlib=rb-4.1.0",
  marineLogistics:
    "https://images.unsplash.com/photo-1769144256207-bc4bb75b29db?crop=entropy&cs=srgb&fm=webp&q=80&w=1400&ixlib=rb-4.1.0",
  marineLogisticsDetail:
    "https://customer-assets-jai6qajn.emergentagent.net/job_mauresk-offshore/artifacts/fg8e0924_a6870060986ba119d4b83286488843a9.jpg",
  shipChartering:
    "https://images.unsplash.com/photo-1642864835712-a9e172ceeafe?crop=entropy&cs=srgb&fm=webp&q=80&w=1400&ixlib=rb-4.1.0",
  shipManagement:
    "https://images.unsplash.com/photo-1566995956590-7731f4b389ee?crop=entropy&cs=srgb&fm=webp&q=80&w=1400&ixlib=rb-4.1.0",
  manpower:
    "https://images.unsplash.com/photo-1516216628859-9bccecab13ca?crop=entropy&cs=srgb&fm=webp&q=80&w=1400&ixlib=rb-4.1.0",
  welding:
    "https://images.unsplash.com/photo-1561536441-01351ded5ffd?crop=entropy&cs=srgb&fm=webp&q=80&w=1400&ixlib=rb-4.1.0",
  meeting:
    "https://images.unsplash.com/photo-1758518730083-4c12527b6742?crop=entropy&cs=srgb&fm=webp&q=80&w=1400&ixlib=rb-4.1.0",
  worker:
    "https://images.unsplash.com/photo-1622612063021-116cc3407145?crop=entropy&cs=srgb&fm=webp&q=80&w=1200&ixlib=rb-4.1.0",
  vesselSunset:
    "https://images.unsplash.com/photo-1568347877321-f8935c7dc5a3?crop=entropy&cs=srgb&fm=webp&q=80&w=1600&ixlib=rb-4.1.0",
  cta: "https://images.unsplash.com/photo-1763258189525-0d7b341243a0?crop=entropy&cs=srgb&fm=webp&q=78&w=1600&ixlib=rb-4.1.0",
};

export const COMPANY = {
  name: "Mauresk Services",
  email: "commercial@maureskoffshore.com",
  phones: ["+33 782 59 90 64", "+971 58 548 1027"],
  location: "Ajman Offshore Zone, United Arab Emirates",
};

export const STATS = [
  { value: 15, suffix: "+", label: "Years Experience" },
  { value: 100, suffix: "%", label: "Commitment" },
  { value: 24, suffix: "/7", label: "Support" },
  { value: null, display: "Global", label: "Operations" },
];

export const CORE_VALUES = [
  {
    icon: "ShieldCheck",
    title: "Reliability",
    text: "Operations you can depend on, delivered consistently and on schedule, every single time.",
  },
  {
    icon: "Zap",
    title: "Agility",
    text: "Fast mobilisation and responsive support that keeps your offshore project moving.",
  },
  {
    icon: "Handshake",
    title: "Commitment",
    text: "Long-term partnerships built on transparency, accountability and shared success.",
  },
  {
    icon: "LifeBuoy",
    title: "Safety",
    text: "Uncompromising adherence to international HSE and marine safety standards.",
  },
  {
    icon: "Award",
    title: "Professionalism",
    text: "Highly qualified crews and specialists representing the highest industry standards.",
  },
  {
    icon: "Gauge",
    title: "Operational Excellence",
    text: "Precision-driven marine logistics engineered for performance and efficiency.",
  },
];

export const SERVICES = [
  {
    slug: "marine-logistics",
    icon: "Ship",
    title: "Marine Logistics",
    short:
      "End-to-end offshore supply chain and marine transport for demanding Oil & Gas operations.",
    image: IMAGES.marineLogistics,
    detailImage: IMAGES.marineLogisticsDetail,
    items: [
      "Offshore supply base coordination",
      "Vessel scheduling & routing",
      "Cargo handling & transfer",
      "Port & customs support",
      "Fuel and provisions logistics",
    ],
  },
  {
    slug: "ship-chartering",
    icon: "Anchor",
    title: "Ship Chartering",
    short:
      "A versatile fleet of offshore vessels chartered to match every phase of your project.",
    image: IMAGES.shipChartering,
    items: [
      "Supply Vessels",
      "Anchor Handlers",
      "Crew Boats",
      "Security Boats",
      "Crane Vessels",
      "Accommodation Barges",
      "Semi-Submersibles",
      "Flat Barges",
    ],
  },
  {
    slug: "ship-crew-management",
    icon: "Compass",
    title: "Ship & Crew Management",
    short:
      "Full technical and marine management ensuring compliant, efficient and safe operations.",
    image: IMAGES.shipManagement,
    items: [
      "ISM Compliance",
      "ISPS Compliance",
      "Safety Management",
      "Fleet Management",
      "Crew Management",
      "Technical Management",
      "Operational Support",
      "Marine Administration",
    ],
  },
  {
    slug: "manpower-services",
    icon: "HardHat",
    title: "Manpower Services",
    short:
      "Highly qualified offshore professionals across every discipline of the Oil & Gas industry.",
    image: IMAGES.manpower,
    items: [
      "Drilling & Well Services",
      "Production Operations",
      "Maintenance",
      "Inspection",
      "HSE",
      "Quality Control",
      "Engineering",
      "Mechanical Support",
      "Electrical Support",
      "Instrumentation",
      "Marine Crew",
      "Offshore Crew",
      "Technical Specialists",
    ],
  },
];

export const WHY_CHOOSE = [
  { icon: "CalendarClock", title: "15+ Years Experience", text: "Proven offshore track record across the global Oil & Gas industry." },
  { icon: "Users", title: "Highly Qualified Professionals", text: "Certified crews and specialists ready for any offshore discipline." },
  { icon: "ShieldCheck", title: "International Safety Standards", text: "Full ISM, ISPS and HSE compliance on every operation." },
  { icon: "Settings", title: "Reliable Operations", text: "Consistent, dependable delivery you can plan around." },
  { icon: "Timer", title: "Fast Response", text: "Rapid mobilisation to keep your project on schedule." },
  { icon: "Globe2", title: "Worldwide Support", text: "Operational reach and support wherever your project is located." },
  { icon: "Gauge", title: "Operational Excellence", text: "Efficiency-driven logistics optimised for performance." },
  { icon: "Headset", title: "Dedicated Customer Service", text: "A single, responsive point of contact throughout your project." },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Mission", to: "/mission" },
  { label: "Why Choose Us", to: "/why-choose-us" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
export const VESSEL_OPTIONS = SERVICES[1].items;
